<template>
    <FormControl
        label="Collect payments"
        :error="
            errors?.getValidationError(
                RequestBodyKeyEnum.App_UpdateService_IsPaymentRequired,
            )
        "
    >
        <CheckboxInput
            label="Enabled"
            :name="RequestBodyKeyEnum.App_UpdateService_IsPaymentRequired"
            :checked="isPaymentRequired"
            @update:modelValue="handlePaymentRequiredUpdated"
        />
    </FormControl>

    <FormControl
        label="Provider"
        :error="
            errors?.getValidationError(
                RequestBodyKeyEnum.App_UpdateService_IntegrationId,
            )
        "
    >
        <!-- TODO: Refactor to radio buttons -->
        <SelectInput
            :name="RequestBodyKeyEnum.App_UpdateService_IntegrationId"
            v-model="selectedIntegrationId"
            :disabled="isPaymentRequired === false"
        >
            <option value="">None</option>
            <template
                v-for="integration in paymentIntegrations"
                :key="integration.id.value"
            >
                <option :value="integration.id.value.toString()">
                    {{ integration.name }}
                </option>
            </template>
        </SelectInput>
    </FormControl>
</template>

<script setup lang="ts">
    import { ref, type PropType } from 'vue'
    import ServiceAggregate from '@/App/Service/Entity/ServiceAggregate'
    import FormControl from '@/Shared/Component/Forms/FormControl.vue'
    import CheckboxInput from '@/Shared/Component/Forms/CheckboxInput.vue'
    import Integration from '@/App/Integration/Entity/Integration'
    import SelectInput from '@/Shared/Component/Forms/SelectInput.vue'
    import ApiFormErrors from '@/Shared/Component/Forms/ApiFormErrors'
    import { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'

    const props = defineProps({
        serviceAggregate: {
            type: Object as PropType<ServiceAggregate | null>,
            default: null,
        },
        paymentIntegrations: {
            type: Array as PropType<Integration[]>,
            required: true,
        },
        errors: {
            type: Object as PropType<ApiFormErrors>,
            required: true,
        },
    })

    const isPaymentRequired = ref(
        props.serviceAggregate?.service?.isPaymentRequired ?? false,
    )
    const selectedIntegrationId = ref(
        props.serviceAggregate?.getIntegrationId()?.value.toString() ?? '',
    )

    const handlePaymentRequiredUpdated = (value: boolean) => {
        isPaymentRequired.value = value

        if (isPaymentRequired.value) {
            return
        }

        selectedIntegrationId.value = ''
    }
</script>
